import { defineRouting } from 'next-intl/routing';

export const routing = defineRouting({
  locales: ['en', 'es', 'de', 'fr', 'it'],
  defaultLocale: 'en',
  localePrefix: 'as-needed', // English (default) won't have prefix, other languages will
  localeDetection: false,
  alternateLinks: false,
});